import React from "react";
import SEO from "../components/SEO.jsx";
import Header from "../partials/header/Header.jsx";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb.js";
import Footer from "../container/Footer/Footer.js";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo.js";

const CallForPaper = () => {
  return (
    <React.Fragment>
      <SEO title="Call for Papers & Abstracts | ICSI 2025" />
      <Header />
      <Breadcrumb
        image="images/banner/banner.jpg"
        title="Call for Papers & Abstracts"
        content="For Authors"
        contentTwo="Call for Papers & Abstracts"
        linkage="/"
      />

      <EmptyTwo>
        <div className="entry-content">
          <h2>Call for Papers</h2>
          <p>
            The International Conference on Swarm Intelligence (ICSI) 2025 invites
            researchers, practitioners, and industry experts to submit their
            original research papers and abstracts. ICSI 2025 aims to provide a
            platform for discussing the latest advancements in swarm intelligence,
            evolutionary computing, and related fields.
          </p>

          <h3>Topic Areas</h3>
          <table className="topic">
            <tbody>
              <tr>
                <th width="100">Theories</th>
                <th width="100">Algorithms</th>
                <th width="100">Realizations</th>
                <th width="100">Emerging Areas</th>
                <th width="100">Applications</th>
              </tr>
              <tr>
                <td>
                  <ul>
                    <li>Swarm intelligence optimization theories</li>
                    <li>Swarm computing</li>
                    <li>Swarm emulation</li>
                    <li>Natural computing</li>
                    <li>Evolutionary computing</li>
                    <li>Social evolution</li>
                    <li>Cooperative theories</li>
                    <li>Optimization theories</li>
                    <li>Immune system theory</li>
                    <li>Multi-agent system theories</li>
                    <li>Reinforcement learning</li>
                    <li>Swarm Robotics</li>
                    <li>Evolutionary learning</li>
                    <li>Collective intelligence</li>
                    <li>Social intelligence</li>
                  </ul>
                </td>

                <td>
                  <ul>
                    <li>PSO algorithms</li>
                    <li>ACO algorithms</li>
                    <li>Fireworks algorithms</li>
                    <li>Fish school search</li>
                    <li>Bees algorithms</li>
                    <li>ABC algorithms</li>
                    <li>BSO algorithms</li>
                    <li>Cultural algorithms</li>
                    <li>Social computing</li>
                    <li>Genetic algorithms</li>
                    <li>Differential evolution</li>
                    <li>Memetic algorithms</li>
                    <li>Bioinspired algorithm</li>
                    <li>Cuckoo / Firefly / Bat / Pelican Algorithms</li>
                    <li>Biogeography-based Optimization</li>
                    <li>Evolutionary strategy</li>
                    <li>Evolutionary Learning systems</li>
                    <li>GPU Computing</li>
                    <li>Other swarm-based algorithms</li>
                  </ul>
                </td>

                <td>
                  <ul>
                    <li>Swarm models</li>
                    <li>Swarm cooperation</li>
                    <li>Multi-agent systems</li>
                    <li>AIS system</li>
                    <li>Evolv. intelligent agents</li>
                    <li>Analytic models of emergent behaviors</li>
                    <li>Evolving fuzzy system</li>
                    <li>Evolving neural nets</li>
                    <li>Artificial life</li>
                    <li>Bio-inspired computing models</li>
                    <li>Socio-inspired computing models</li>
                    <li>Routing and scheduling</li>
                    <li>MOO, Many-OO</li>
                    <li>Constrained OP</li>
                    <li>Dynamic OP</li>
                    <li>Combinatorial OP</li>
                    <li>GPU Parallelization</li>
                    <li>Other swarm-based systems</li>
                  </ul>
                </td>

                <td>
                  <ul>
                    <li>Large language models</li>
                    <li>Swarm intelligence & evolutionary computing for large language model optimization</li>
                    <li>Large language model based evolution computation</li>
                    <li>Large language model based swarm intelligence</li>
                    <li>Large language model based multi-agent systems</li>
                    <li>Molecular computing</li>
                    <li>DNA computing</li>
                    <li>Quantum computing</li>
                    <li>Granularity computing</li>
                    <li>Deep computing</li>
                    <li>Pervasive computing</li>
                    <li>Cloud computing</li>
                    <li>Metaverse</li>
                  </ul>
                </td>

                <td>
                  <ul>
                    <li>UAV control</li>
                    <li>Swarm cooperation</li>
                    <li>Automatic control</li>
                    <li>Intelligent transport</li>
                    <li>Information security</li>
                    <li>Machine learning</li>
                    <li>Image Processing</li>
                    <li>Image Recognition</li>
                    <li>Neural Network</li>
                    <li>Robotic manipulator</li>
                    <li>Cognitive robots</li>
                    <li>Virtual swarms</li>
                    <li>AR+VR techniques</li>
                    <li>Bioinformatics</li>
                    <li>Telecommunications</li>
                    <li>Underwater vehicles</li>
                    <li>Automatic driving</li>
                    <li>Games</li>
                    <li>Internet+ techniques</li>
                    <li>Data mining</li>
                    <li>Other SI applications</li>
                  </ul>
                </td>
              </tr>
            </tbody>
          </table>

          <h2>Call for Abstracts</h2>
          <p>
            In addition to full paper submissions, ICSI 2025 welcomes the
            submission of abstracts for presentation at the conference. Abstracts
            provide an excellent opportunity for researchers to share their
            ongoing work, preliminary results, or innovative ideas with the
            community.
          </p>

          <h3>Abstract Submission Guidelines</h3>
          <ul>
            <li>
              <strong>Length:</strong> Abstracts should be 1-2 pages in length,
              including references (if any).
            </li>
            <li>
              <strong>Content:</strong> Abstracts should clearly state the
              research problem, methodology, results (if available), and
              conclusions.
            </li>
            <li>
              <strong>Format:</strong> Please use the ICSI 2025 normal paper template
              (template files for <a className="simple-link"
											href="./files/LNCS-Office2007.zip">MS
											Word</a> or <a className="simple-link"
											href="./files/llncs2e.zip">LaTeX2e</a>, or view it on <a className="simple-link"
											href="https://www.overleaf.com/latex/templates/springer-lecture-notes-in-computer-science/kzwwpvhwnvfj#.WuA4JS5uZpi">Overleaf</a> ).
            </li>
            <li>
              <strong>submission: </strong> The abstract of the paper should be submitted in the same system as the formal paper, but it is necessary to select the abstract track within the system.
            </li>
            <li>
              <strong>Language:</strong> Abstracts must be written in English.
            </li>
            <li>
              <strong>Presentation:</strong> Accepted abstracts will be presented
              as either oral presentations or poster sessions, as determined by
              the program committee.
            </li>
            <li>
              <strong>Publication:</strong> Abstracts will not be published in
              the conference proceedings or any database. They are solely for
              presentation at the conference.
            </li>
            <li>
              <strong>Registration:</strong> At least one author of each accepted
              abstract must register for the conference to present their work.
            </li>
          </ul>

          <h3>Important Dates</h3>
          <ul>
            <li>Abstract Submission Deadline: March 31th, 2025</li>
            <li>Notification of Acceptance: 	May 1st, 2025</li>
          </ul>

          <p>
            For any questions regarding abstract submission, please contact us at{" "}
            <a href="mailto:abstracts@icsi2025.org">icsi2025@iasei.org</a>.
          </p>
        </div>
      </EmptyTwo>

      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
};

export default CallForPaper;